import {h, Fragment} from "preact"
import { useAppState } from "@nosto/preact"
import { useEffect, useState } from "preact/hooks"
import { updateSearchTagging } from "../helpers"
import { SERP_REC_ID } from "../config"

import SearchHeader from './SearchHeader'
import Sidebar from "./Sidebar"
import Toolbar from "./Toolbar"
import Products from "./Products"
import Pagination from "./Pagination"
import Loader from "./elements/Loader"
import NoResults from "./NoResults"

export default function Serp() {
    const { query, response: { products }, loading } = useAppState();
    const foundProducts = products && products.total > 0;
    const [ sidebarOpen, setSidebarOpen ] = useState(false);

    useEffect(() => {
        if(!query?.query) return;
        updateSearchTagging(query.query);

        if(window.nostojs) {
            window.nostojs(api => {
                api
                .createRecommendationRequest({ includeTagging: true })
                .setElements([ SERP_REC_ID ])
                .load({ skipEvents: true })
            })
        }
    }, [ query?.query ])

    useEffect(() => {
        const bodyEl = document.body;
        if(bodyEl) {
            bodyEl.classList.toggle('overflow-hidden', sidebarOpen);
            return () => bodyEl.classList.remove('overflow-hidden');
        }
    }, [ sidebarOpen ]);

    const toggleSidebar = () => {
        setSidebarOpen(prevSidebarOpen => !prevSidebarOpen);
    }

    return (
        <div className="ns-serp" data-nosto-element="search">
            {(foundProducts) ? (
                <>
                    <Sidebar
                        sidebarOpen={sidebarOpen}
                        toggleSidebar={toggleSidebar}
                    />
                    <SearchHeader />
                    <Toolbar 
                        toggleSidebar={toggleSidebar} 
                    />
                    <div className="ns-serp-inner px-6 lg:px-[30px] py-4">
                        <Products />
                        <Pagination />
                    </div>
                    <div class="nosto_element" id={SERP_REC_ID} />
                </>
            ) : (loading) ? (
                <Loader />
            ) : (
                <SearchHeader />
            )}
        </div>
    )
}
